import { createFilterObj } from "./filterUtils.js";
import dayjs from "dayjs";

export function createProductionOrderFilters(rows) {
  const current_datetime = dayjs();
  const filters = {
    "YearFilter": createFilterObj({
      name: "YearFilter",
      filteredPropertyName: "Work_OperationProductionStartTime",
      target: "加工年",
    }),
    "MonthFilter": createFilterObj({
      name: "MonthFilter",
      filteredPropertyName: "Work_OperationProductionStartTime",
      target: "加工月",
    }),
    "ProcessFilter": createFilterObj({
      name: "ProcessFilter",
      filteredPropertyName: "Work_OperationProcName",
      target: "工程",
    }),
    "TaseibanFilter": createFilterObj({
      name: "TaseibanFilter",
      filteredPropertyName: "WorkUser_TaSeiban",
      target: "製番",
    }),
    "WorkOrderItemFilter": createFilterObj({
      name: "WorkOrderItemFilter",
      filteredPropertyName: "Work_OrderItem",
      target: "品番",
    }),
    "OrderFilter": createFilterObj({
      name: "OrderFilter",
      filteredPropertyName: "Order_Code",
      target: "オーダ",
    }),
    "CompletedFilter": createFilterObj({
      name: "CompletedFilter",
      filteredPropertyName: "Work_ResultEndTime",
      target: "完了品/未完了品",
    }),
  }
  for (const key in filters) {
    if (key === "YearFilter") {
      const dynamicItems = filters[key].getFilterItems(rows, {[key]: filters[key]}).map(item => ({
        ...item,
        excluded: false,
      }));

      const manualItems = [
        { text: current_datetime.format("YYYY"), displayed: true, excluded: false },
      ].filter(item => !dynamicItems.some(dynamic => dynamic.text === item.text));
      filters[key].items = [...dynamicItems, ...manualItems];
    } else if (key === "MonthFilter") {
      filters[key].items = Array.from({ length: 12 }, (_, i) => ({
        text: (i + 1).toString(),
        displayed: true,
        excluded: false,
      }));
    } else {
      filters[key].items = filters[key].getFilterItems(rows, {[key]: filters[key]})
    }
    
  }
  return filters
}
